import { conversationsApi } from "@/services/conversation-service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
type TPayload = Parameters<typeof conversationsApi.updateConversation>[1]
export const useRenameConversation = (id: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (newName: string) => {
      return conversationsApi.updateConversation(id, { name: newName } as TPayload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversations"] });
      queryClient.invalidateQueries({ queryKey: ["conversation", id] });
    },
  });
  return mutation;
};
